import { ReviewEntriesFilterType } from '../enums/reviewEntriesFilterType'
import type { ReviewEntriesAmountRangeFilter, ReviewEntriesFiltersState } from '../types/reviewEntriesFilters'
import { isAmountRangeFilterEmpty } from './isReviewEntriesFilterValueEmpty'

const formatAmountRangePreview = (range: ReviewEntriesAmountRangeFilter | undefined): string | undefined => {
  if (isAmountRangeFilterEmpty(range) || !range) {
    return undefined
  }

  const { from, to } = range

  if (from !== undefined && to !== undefined) {
    return `${from} - ${to}`
  }

  if (from !== undefined) {
    return String(from)
  }

  if (to !== undefined) {
    return String(to)
  }

  return undefined
}

export const formatReviewEntriesFilterPreview = (
  type: ReviewEntriesFilterType,
  filters: ReviewEntriesFiltersState,
): string | undefined => {
  switch (type) {
    case ReviewEntriesFilterType.Supplier:
      return filters.supplier?.join(', ')
    case ReviewEntriesFilterType.Account:
      return filters.account?.join(', ')
    case ReviewEntriesFilterType.VatRate:
      return filters.vatRate?.join(', ')
    case ReviewEntriesFilterType.ExclVat:
      return formatAmountRangePreview(filters.exclVat)
    case ReviewEntriesFilterType.InclVat:
      return formatAmountRangePreview(filters.inclVat)
    default:
      return undefined
  }
}
